import { Component, ContentChild } from '@angular/core'
import { MatFormField } from '@angular/material/form-field'
import { FormControlDirective, FormControlName } from '@angular/forms'

@Component({
  selector: 'lin-form-field',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        margin: 10px 0;
      }

      :host ::ng-deep .mat-mdc-form-field-error {
        font-size: 75%;
      }
    `,
  ],
  providers: [
    {
      provide: MatFormField,
      useExisting: FormFieldComponent,
    },
  ],
  standalone: false,
})
export class FormFieldComponent {
  @ContentChild(FormControlDirective, { static: true }) formControlDirective: FormControlDirective
  @ContentChild(FormControlName, { static: true }) formControlName: FormControlName

  constructor() {}

  get _control() {
    const ngControl = this.formControlDirective || this.formControlName
    return { ngControl }
  }
}
